import Vue from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios';

import 'lib-flexible';
import { apis } from './core/apis';
import  './permission';
import * as appUtils from './core/appUtils';
import {ConstStatic} from './core/constStatic';
import {HttpServer} from './core/http.server';
import '@/core/lazy_lib/components_use'
import './components/global.less'
import { Dialog } from '@/components';
import 'ant-design-vue/dist/antd.css';
import { Anchor, FormModel,BackTop,carousel,message } from 'ant-design-vue';
Vue.use(FormModel);
Vue.use(Anchor);
Vue.use(carousel);
Vue.use(BackTop);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


Vue.config.productionTip = false;
Vue.prototype.axios = axios;

Vue.prototype.apis = apis.api;
Vue.prototype.appUtils = appUtils;
Vue.prototype.constStatic = ConstStatic;
Vue.prototype.http = HttpServer;

router.beforeEach((to,from,next) =>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next();
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
